export const categories = [
  {
    name: "Romance",
    slug: "romance",
    image: "https://images.pexels.com/photos/1024980/pexels-photo-1024980.jpeg",
  },
  {
    name: "Fantasy",
    slug: "fantasy",
    image: "https://images.pexels.com/photos/356133/pexels-photo-356133.jpeg",
  },
  {
    name: "Short stories",
    slug: "short-stories",
    image: "https://images.pexels.com/photos/256541/pexels-photo-256541.jpeg",
  },
  {
    name: "Culture",
    slug: "culture",
    image: "https://images.pexels.com/photos/573552/pexels-photo-573552.jpeg",
  },
  {
    name: "Adventure",
    slug: "adventure",
    image: "https://images.pexels.com/photos/1024980/pexels-photo-1024980.jpeg",
  },
  {
    name: "Real-Life",
    slug: "real-life",
    image: "https://images.pexels.com/photos/145939/pexels-photo-145939.jpeg",
  },
  {
    name: "Mythology",
    slug: "mythology",
    image: "https://images.pexels.com/photos/1024980/pexels-photo-1024980.jpeg",
  },
  {
    name: "Mystery",
    slug: "mystery",
    image: "https://images.pexels.com/photos/289367/pexels-photo-289367.jpeg",
  },
  {
    name: "Thriller",
    slug: "thriller",
    image: "https://images.pexels.com/photos/799443/pexels-photo-799443.jpeg",
  },
];

export const categoriesM = [
  { name: "Romance", slug: "romance" },
  { name: "Fantasy", slug: "fantasy" },
  { name: "Short Stories", slug: "short-stories" },
  { name: "Culture", slug: "culture" },
  { name: "Action", slug: "action" },
  { name: "Adventure", slug: "adventure" },
  { name: "Real-Life", slug: "real-life" },
  { name: "Mythology", slug: "mythology" },
  { name: "Psychological", slug: "psychological" },
  { name: "Sci-Fi", slug: "sci-fi" },
  { name: "Comedy", slug: "comedy" },
  { name: "Poetry", slug: "poetry" },
  { name: "Drama", slug: "drama" },
  { name: "Empowerment", slug: "empowerment" },
  { name: "Campus Stories", slug: "campus-stories" },
  { name: "Thriller", slug: "thriller" },
  { name: "Horror", slug: "horror" },
  { name: "Mystery", slug: "mystery" },
  { name: "Modern Society", slug: "modern-society" },
  { name: "African Proverbs", slug: "african-proverbs" },
  { name: "Lifestyle", slug: "lifestyle" },
  { name: "Flash Fiction", slug: "flash-fiction" },
  { name: "Children’s Stories", slug: "children-stories" },
  { name: "Music & Art", slug: "music-art" },
  { name: "Faith", slug: "faith" },
  { name: "Spirituality", slug: "spirituality" },
  { name: "Historical Tales", slug: "historical-tales" },
  { name: "Crime & Justice", slug: "crime-justice" },
  { name: "Magical Realms", slug: "magical-realms" },
  { name: "Dark Secrets", slug: "dark-secrets" },
  { name: "Technology", slug: "technology" },
  { name: "AI", slug: "ai" },
  { name: "Friendship", slug: "friendship" },
  { name: "Dreams", slug: "dreams" },
  { name: "Ghost Stories", slug: "ghost-stories" },
  { name: "African Myth", slug: "african-myth" },
  { name: "Folklore", slug: "folklore" },
];

export const romanceStories = [
  {
    id: 1,
    title: "The Apothecary Diaries",
    cover: "/covers/apothecary.jpg",
    author: "Natsu Hyuuga",
  },
  {
    id: 2,
    title: "Kaoru Run",
    cover: "/covers/kaoru.jpg",
    author: "Some Author",
  },
];

// data/dummyData.js
export const adventureStories = [
  {
    id: "1",
    title: "Maze Runner: The Scorch Trials",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "James Dashner",
    genres: ["Adventure", "Fantasy"],
    chapters: 501,
    reads: 9100000,
    rating: "9.2",
  },
  {
    id: "2",
    title: "The Apothecary Diaries",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Atsumi David",
    genres: ["Fantasy"],
    chapters: 631,
    reads: 12600000,
    rating: "9.5",
  },
  {
    id: "3",
    title: "The Fragrant Flower Blooms With Dignity",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Romance", "Comedy"],
    chapters: 682,
    reads: 10900000,
    rating: "9.0",
  },
  {
    id: "4",
    title: "Eragon",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Christopher Paolini",
    genres: ["Fantasy", "Action"],
    chapters: 510,
    reads: 13300000,
    rating: "9.6",
  },
  {
    id: "5",
    title: "The Secret of Immortal Nicholas Flamel",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Adventure"],
    chapters: 531,
    reads: 12400000,
    rating: "9.4",
  },
];

export const recommendedStories = [
  {
    id: "6",
    title: "Maze Runner: The Scorch Trials",
    cover: "https://tiimg.tistatic.com/fp/1/008/400/a4-rectangular-printed-english-story-book-for-kids-use--139.jpg",
    author: "James Dashner",
    genres: ["Adventure", "Fantasy"],
    chapters: 501,
    reads: 9100000,
    rating: "9.2",
  },
  {
    id: "7",
    title: "The Apothecary Diaries",
    cover: "https://tiimg.tistatic.com/fp/1/008/400/a4-rectangular-printed-english-story-book-for-kids-use--139.jpg",
    author: "Atsumi David",
    genres: ["Fantasy"],
    chapters: 631,
    reads: 12600000,
    rating: "9.5",
  },
  {
    id: "8",
    title: "The Fragrant Flower Blooms With Dignity",
    cover: "https://tiimg.tistatic.com/fp/1/008/400/a4-rectangular-printed-english-story-book-for-kids-use--139.jpg",
    author: "Adeniyi David",
    genres: ["Romance", "Comedy"],
    chapters: 682,
    reads: 10900000,
    rating: "9.0",
  },
  {
    id: "9",
    title: "Eragon",
    cover: "https://tiimg.tistatic.com/fp/1/008/400/a4-rectangular-printed-english-story-book-for-kids-use--139.jpg",
    author: "Christopher Paolini",
    genres: ["Fantasy", "Action"],
    chapters: 510,
    reads: 13300000,
    rating: "9.6",
  },
  {
    id: "10",
    title: "The Secret of Immortal Nicholas Flamel",
    cover: "https://tiimg.tistatic.com/fp/1/008/400/a4-rectangular-printed-english-story-book-for-kids-use--139.jpg",
    author: "Adeniyi David",
    genres: ["Adventure"],
    chapters: 531,
    reads: 12400000,
    rating: "9.4",
  },
];

export const completedStories = [
  {
    id: "11",
    title: "Maze Runner: The Scorch Trials",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "James Dashner",
    genres: ["Adventure", "Fantasy"],
    chapters: 501,
    reads: 9100000,
    rating: "9.2",
  },
  {
    id: "12",
    title: "The Apothecary Diaries",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Atsumi David",
    genres: ["Fantasy"],
    chapters: 631,
    reads: 12600000,
    rating: "9.5",
  },
  {
    id: "13",
    title: "The Fragrant Flower Blooms With Dignity",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Romance", "Comedy"],
    chapters: 682,
    reads: 10900000,
    rating: "9.0",
  },
  {
    id: "14",
    title: "Eragon",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Christopher Paolini",
    genres: ["Fantasy", "Action"],
    chapters: 510,
    reads: 13300000,
    rating: "9.6",
  },
  {
    id: "15",
    title: "The Secret of Immortal Nicholas Flamel",
    cover: "https://m.media-amazon.com/images/I/81l3rZK4lnL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Adventure"],
    chapters: 531,
    reads: 12400000,
    rating: "9.4",
  },
];

export const NovelStories = [
  {
    id: "11",
    title: "Maze Runner: The Scorch Trials",
    cover: "https://m.media-amazon.com/images/I/91vtgPcLFxL._AC_UF1000,1000_QL80_.jpg",
    author: "James Dashner",
    genres: ["Adventure", "Fantasy"],
    chapters: 501,
    reads: 9100000,
    rating: "9.2",
  },
  {
    id: "12",
    title: "The Apothecary Diaries",
    cover: "https://m.media-amazon.com/images/I/91vtgPcLFxL._AC_UF1000,1000_QL80_.jpg",
    author: "Atsumi David",
    genres: ["Fantasy"],
    chapters: 631,
    reads: 12600000,
    rating: "9.5",
  },
  {
    id: "13",
    title: "The Fragrant Flower Blooms With Dignity",
    cover: "https://m.media-amazon.com/images/I/91vtgPcLFxL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Romance", "Comedy"],
    chapters: 682,
    reads: 10900000,
    rating: "9.0",
  },
  {
    id: "14",
    title: "Eragon",
    cover: "https://m.media-amazon.com/images/I/91vtgPcLFxL._AC_UF1000,1000_QL80_.jpg",
    author: "Christopher Paolini",
    genres: ["Fantasy", "Action"],
    chapters: 510,
    reads: 13300000,
    rating: "9.6",
  },
  {
    id: "15",
    title: "The Secret of Immortal Nicholas Flamel",
    cover: "https://m.media-amazon.com/images/I/91vtgPcLFxL._AC_UF1000,1000_QL80_.jpg",
    author: "Adeniyi David",
    genres: ["Adventure"],
    chapters: 531,
    reads: 12400000,
    rating: "9.4",
  },
];

export const PowerRankingStories = [
  {
    id: "11",
    title: "Maze Runner: The Scorch Trials",
    cover: "https://mybookishuniverse.com/wp-content/uploads/2023/04/AAAABVCkEcFlOGDq8MmuG95WyBs2ENYO13ONsGmAqkGJzP6XHrJYeE1bGjdXJH4B5A5LJJBJ2PFfAlVyZuOt0987p-sW3EFTKRjVr0Kc.jpg",
    author: "James Dashner",
    genres: ["Adventure", "Fantasy"],
    chapters: 501,
    reads: 9100000,
    rating: "9.2",
  },
  {
    id: "12",
    title: "The Apothecary Diaries",
    cover: "https://mybookishuniverse.com/wp-content/uploads/2023/04/AAAABVCkEcFlOGDq8MmuG95WyBs2ENYO13ONsGmAqkGJzP6XHrJYeE1bGjdXJH4B5A5LJJBJ2PFfAlVyZuOt0987p-sW3EFTKRjVr0Kc.jpg",
    author: "Atsumi David",
    genres: ["Fantasy"],
    chapters: 631,
    reads: 12600000,
    rating: "9.5",
  },
  {
    id: "13",
    title: "The Fragrant Flower Blooms With Dignity",
    cover: "https://mybookishuniverse.com/wp-content/uploads/2023/04/AAAABVCkEcFlOGDq8MmuG95WyBs2ENYO13ONsGmAqkGJzP6XHrJYeE1bGjdXJH4B5A5LJJBJ2PFfAlVyZuOt0987p-sW3EFTKRjVr0Kc.jpg",
    author: "Adeniyi David",
    genres: ["Romance", "Comedy"],
    chapters: 682,
    reads: 10900000,
    rating: "9.0",
  },
  {
    id: "14",
    title: "Eragon",
    cover: "https://mybookishuniverse.com/wp-content/uploads/2023/04/AAAABVCkEcFlOGDq8MmuG95WyBs2ENYO13ONsGmAqkGJzP6XHrJYeE1bGjdXJH4B5A5LJJBJ2PFfAlVyZuOt0987p-sW3EFTKRjVr0Kc.jpg",
    author: "Christopher Paolini",
    genres: ["Fantasy", "Action"],
    chapters: 510,
    reads: 13300000,
    rating: "9.6",
  },
  {
    id: "15",
    title: "The Secret of Immortal Nicholas Flamel",
    cover: "https://mybookishuniverse.com/wp-content/uploads/2023/04/AAAABVCkEcFlOGDq8MmuG95WyBs2ENYO13ONsGmAqkGJzP6XHrJYeE1bGjdXJH4B5A5LJJBJ2PFfAlVyZuOt0987p-sW3EFTKRjVr0Kc.jpg",
    author: "Adeniyi David",
    genres: ["Adventure"],
    chapters: 531,
    reads: 12400000,
    rating: "9.4",
  },
];


export const mysteryThrillerStories = [
  {
    id: 1,
    title: "The Secret of Immortal Nicholas II",
    author: "Adventure David",
    badge: "Muscle",
    series: null,
    additionalText: null,
    variants: [
      { author: "Edward Dashner" },
      { author: "Edward Dashner" },
      { author: "Edward Dashner" }
    ]
  },
  {
    id: 2,
    title: "The Asher",
    author: "Adventure David",
    badge: null,
    series: null,
    additionalText: null,
    variants: [
      { author: "Edward Dashner" },
      { author: "Edward Dashner" },
      { author: "Edward Dashner" }
    ]
  }
];

export const powerRankingStories = [
  {
    id: 1,
    title: "Top Mystery Story 1",
    author: "Author 1",
    badge: "Hot",
    series: null,
    additionalText: null,
  },
  {
    id: 2,
    title: "Top Mystery Story 2",
    author: "Author 2",
    badge: "Trending",
    series: null,
    additionalText: null,
  },
  {
    id: 3,
    title: "Top Mystery Story 3",
    author: "Author 3",
    badge: null,
    series: null,
    additionalText: null,
  },
];

export const chapters = [
  { id: 0, title: "00: Prologue – The Night Everything Changed", isFree: true, content: "The night everything changed began quietly, but the echoes would last forever. Shadows moved through the streets of Greyford as fate took its first step." },
  { id: 1, title: "01: A Letter That Shouldn’t Exist", isFree: true, content: "A letter arrived on a rainy morning, its words trembling with secrets that could unravel everything." },
  { id: 2, title: "02: The Return to Greyford", isFree: true, content: "Returning to Greyford was bittersweet; familiar streets held memories both sweet and painful." },
  { id: 3, title: "03: Old Faces, New Secrets", isFree: true, content: "Old friends greeted with smiles, yet behind those smiles, secrets whispered in silence." },
  { id: 4, title: "04: Whispers Behind Closed Doors", isFree: true, content: "The mansion’s corridors were alive with whispers, each one hiding truths that no one dared speak aloud." },
  { id: 5, title: "05: The Promise He Never Kept", isFree: true, content: "Promises made in youthful hope can become chains; his words were heavy with unkept oaths." },

  { id: 6, title: "06: Shadows in the Morning Light", isFree: false, content: "Even in the morning light, shadows lingered, reminding everyone of the night’s unresolved secrets." },
  { id: 7, title: "07: The Girl at Platform Seven", isFree: false, content: "She stood at platform seven, a stranger with eyes that told a thousand untold stories." },
  { id: 8, title: "08: Lies Dressed as Truth", isFree: false, content: "What appeared true was often the most dangerous lie, carefully woven into reality." },
  { id: 9, title: "09: A House Full of Memories", isFree: false, content: "The house held memories like cobwebs, delicate and easily torn apart with a single touch." },
  { id: 10, title: "10: The First Warning", isFree: false, content: "A subtle warning came with the wind, whispering that nothing would remain the same." },

  { id: 11, title: "11: When Trust Begins to Crack", isFree: false, content: "Trust, once solid, started to fracture under pressure, leaving uncertainty in its wake." },
  { id: 12, title: "12: A Name From the Past", isFree: false, content: "A familiar name brought back memories that some hoped had been buried forever." },
  { id: 13, title: "13: Footsteps in the Dark", isFree: false, content: "Footsteps echoed through the darkened halls, each one carrying a secret intent." },
  { id: 14, title: "14: The Cost of Silence", isFree: false, content: "Silence can be expensive; each unspoken word left a mark unseen but deeply felt." },
  { id: 15, title: "15: What Was Hidden in Plain Sight", isFree: false, content: "The truth had been there all along, hiding in plain sight, waiting for someone to notice." },

  { id: 16, title: "16: An Unexpected Ally", isFree: false, content: "Help came from where it was least expected, altering the balance of trust." },
  { id: 17, title: "17: Broken Promises and Bruised Hearts", isFree: false, content: "Promises shattered, hearts bruised, yet the fight to move forward continued." },
  { id: 18, title: "18: The Diary Beneath the Floorboards", isFree: false, content: "A diary hidden beneath the floorboards revealed truths no one was ready to face." },
  { id: 19, title: "19: Every Choice Has a Price", isFree: false, content: "Every decision carried a cost, unseen at first but unavoidable in time." },
  { id: 20, title: "20: The Truth Doesn’t Set You Free", isFree: false, content: "Sometimes, the truth is heavier than lies, anchoring those who seek it." },

  { id: 21, title: "21: Storms Over Greyford", isFree: false, content: "Greyford’s skies darkened as storms gathered, mirroring the turmoil below." },
  { id: 22, title: "22: A Deal Made in Desperation", isFree: false, content: "Desperation leads to deals no one would make in calm waters." },
  { id: 23, title: "23: When the Past Fights Back", isFree: false, content: "The past resurfaced with a vengeance, challenging every choice made since." },
  { id: 24, title: "24: The Enemy You Know", isFree: false, content: "Familiar faces carried hidden threats, enemies cloaked in friendship." },
  { id: 25, title: "25: Halfway to Ruin", isFree: false, content: "The journey toward ruin was halfway complete, with no way to turn back." },

  { id: 26, title: "26: The Night of the Fire", isFree: false, content: "Flames consumed more than wood; secrets and lies were burned in the blaze." },
  { id: 27, title: "27: Ashes and Accusations", isFree: false, content: "Ashes carried accusations, blame scattered with every gust of wind." },
  { id: 28, title: "28: The One Who Disappeared", isFree: false, content: "A disappearance left voids in hearts and minds, questions with no answers." },
  { id: 29, title: "29: Trust No One", isFree: false, content: "Trust became a rare commodity; caution was now the only ally." },
  { id: 30, title: "30: What They Were Afraid Of", isFree: false, content: "Fear had a face, and now it stared directly at them." },

  { id: 31, title: "31: Crossing the Line", isFree: false, content: "Boundaries were crossed, consequences inevitable, lines forever blurred." },
  { id: 32, title: "32: The Confession", isFree: false, content: "A confession revealed truths that some wished had remained buried." },
  { id: 33, title: "33: A Trap Carefully Set", isFree: false, content: "Every step forward was a step into a trap laid with precision." },
  { id: 34, title: "34: The Longest Night", isFree: false, content: "Time dragged endlessly through a night that seemed eternal." },
  { id: 35, title: "35: Nothing Will Ever Be the Same", isFree: false, content: "After events unfolded, the world could never return to what it once was." },

  { id: 36, title: "36: Pieces of the Puzzle", isFree: false, content: "The pieces of the puzzle slowly fit together, forming a picture both shocking and inevitable." },
  { id: 37, title: "37: The Truth at Last", isFree: false, content: "Finally, the truth emerged, bringing clarity at a cost." },
  { id: 38, title: "38: Betrayal Cuts Deepest", isFree: false, content: "Betrayal left scars deeper than any wound, invisible yet piercing." },
  { id: 39, title: "39: Facing the Consequences", isFree: false, content: "Consequences came swift and unforgiving, forcing reflection and growth." },
  { id: 40, title: "40: When Everything Falls Apart", isFree: false, content: "Everything collapsed in chaos, leaving only the desperate to endure." },

  { id: 41, title: "41: The Final Chase", isFree: false, content: "The last chase began, hearts pounding, time slipping away." },
  { id: 42, title: "42: One Last Decision", isFree: false, content: "A single decision would decide the fate of all involved." },
  { id: 43, title: "43: The Price of the Truth", isFree: false, content: "Truth demanded its price, paid in trust, love, and pain." },
  { id: 44, title: "44: What Was Lost and Found", isFree: false, content: "Some things were lost forever, others unexpectedly found." },
  { id: 45, title: "45: The Calm After the Storm", isFree: false, content: "After the turmoil, a fragile calm settled over Greyford." },

  { id: 46, title: "46: A New Beginning", isFree: false, content: "New beginnings arose from the ashes of the past, tentative yet hopeful." },
  { id: 47, title: "47: Scars That Remain", isFree: false, content: "Even after healing, scars remained, reminding everyone of what was endured." },
  { id: 48, title: "48: Lessons Written in Pain", isFree: false, content: "Pain taught lessons that could never be forgotten." },
  { id: 49, title: "49: Epilogue – The Story Continues", isFree: false, content: "The story did not end, but continued in whispers, in memories, and in hearts." },
];


